import { defineComponent as _defineComponent } from 'vue'
type ToggleProps = {
  checked: boolean,
  name: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Toggle',
  props: {
    checked: { type: Boolean },
    name: null
  },
  emits: ['change'],
  setup(__props: any, { emit }) {

const props = __props as {
  checked: boolean,
  name: string
};




function onChange(checked: Event) {
  emit('change', (checked.target as HTMLInputElement).checked);
}

return { __sfc: true,props, emit, onChange }
}

})